import type { RoadDiagramSpec } from '../lib/roadDiagram';

const allStops: RoadDiagramSpec['signs'] = [
  { kind: 'stop', at: 'north' },
  { kind: 'stop', at: 'south' },
  { kind: 'stop', at: 'east' },
  { kind: 'stop', at: 'west' },
];

export const allWayTogether: RoadDiagramSpec = {
  template: 'intersection',
  signs: allStops,
  vehicles: [
    { label: 'A', from: 'south', intent: 'stop' },
    { label: 'B', from: 'east', intent: 'straight' },
  ],
};

/** Same intersection, revealed one layer at a time. */
export const allWayLayers: RoadDiagramSpec = {
  template: 'intersection',
  build: 'all-way',
  signs: allStops,
  layers: [
    { id: 'car-a', vehicles: [{ label: 'A', from: 'south', intent: 'stop' }], labels: true },
    { id: 'car-b', vehicles: [{ label: 'B', from: 'east', intent: 'straight' }], labels: true },
    { id: 'who', arrows: true, labels: true },
  ],
};

export function allWayStep(reveal: string[]): RoadDiagramSpec {
  return { ...allWayLayers, reveal };
}

export const allWayFirst: RoadDiagramSpec = {
  template: 'intersection',
  signs: allStops,
  vehicles: [
    { label: 'A', from: 'south', intent: 'straight' },
    { label: 'B', from: 'west', intent: 'stop', back: true },
  ],
};

export const crosswalkStop: RoadDiagramSpec = {
  template: 'parking',
  crosswalk: true,
  walker: true,
  vehicles: [{ label: 'A', from: 'west', intent: 'stop' }],
};

export const doNotPass: RoadDiagramSpec = {
  template: 'parking',
  crosswalk: true,
  walker: true,
  vehicles: [
    { label: 'A', from: 'west', intent: 'stop' },
    { label: 'B', from: 'west', intent: 'stop' },
  ],
};

export const stopAtLine: RoadDiagramSpec = {
  template: 'parking',
  crosswalk: true,
  signs: [{ kind: 'stop' }],
  vehicles: [{ label: 'A', from: 'west', intent: 'stop' }],
};

export const yieldSign: RoadDiagramSpec = {
  template: 'sign',
  sign: 'yield',
};

export const stopSign: RoadDiagramSpec = {
  template: 'sign',
  sign: 'stop',
};

export const warningSign: RoadDiagramSpec = {
  template: 'sign',
  sign: 'warning',
};

export const leftTurn: RoadDiagramSpec = {
  template: 'intersection',
  vehicles: [
    { label: 'A', from: 'south', intent: 'left' },
    { label: 'B', from: 'north', intent: 'straight' },
  ],
};

export const schoolBus: RoadDiagramSpec = {
  template: 'two-lane',
  median: false,
  vehicles: [
    { label: 'A', from: 'west', intent: 'stop', kind: 'bus' },
    { label: 'B', from: 'west', intent: 'stop' },
    { label: 'C', from: 'east', intent: 'stop' },
  ],
};

export const dividedBus: RoadDiagramSpec = {
  template: 'two-lane',
  median: true,
  vehicles: [
    { label: 'A', from: 'west', intent: 'stop', kind: 'bus' },
    { label: 'C', from: 'east', intent: 'straight' },
  ],
};

export const roundaboutYield: RoadDiagramSpec = {
  template: 'roundabout',
  signs: [{ kind: 'yield', at: 'south' }],
  vehicles: [
    { label: 'A', from: 'south', intent: 'yield' },
    { label: 'B', from: 'west', intent: 'straight' },
  ],
};

export const headlights: RoadDiagramSpec = {
  template: 'two-lane',
  rain: true,
  vehicles: [{ label: 'A', from: 'west', intent: 'straight', lights: true }],
};
